/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import Table from "../../components/table/Table";
import api from "../../services/api";
import { formatDateTime } from "../../helpers/helpers";
import pedidoEvento from "../../enums/pedidoEvento";
import serverHost from "../../services/serverHost";
import AppContext from "../../container/context";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";

const Pedido = ({ history, match }) => {
  const [pedidoId] = useState(Number(match.params.id));

  const [carregando, setCarregando] = useState(true);
  const [pedido, setPedido] = useState({});
  const [confirmacaoCancelamento, setConfirmacaoCancelamento] = useState(false);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    api
      .get("pedidos/carregar", { id: pedidoId })
      .then((pedido) => {
        pedido.itens.forEach((pi) => {
          pi.valorUnitario = `R$ ${(pi.pedidoItemValor / 100).toFixed(2)}`;
          pi.valorTotal = `R$ ${(
            (pi.pedidoItemValor * pi.pedidoItemQtd) /
            100
          ).toFixed(2)}`;
        });

        pedido.cancelavel = pedido.eventos && pedido.eventos.length === 0;

        setPedido(pedido);
        setCarregando(false);
      })
      .catch((e) => notification("error", `Erro:  ${e} `));
  };

  const registrosTbItens = montarTabelaItens(pedido.itens);

  const registrosTbPagamentos = montarTabelaPagamentos(
    pedido.pagamentos,
    history
  );

  const registrosTbEventos = montarTabelaEventos(pedido.eventos);

  return (
    <>
      <br />
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <h2>Pedido</h2>
      </Grid>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <div className="main-container">
            <Grid container spacing={2}>
              <Grid item sm={3} xs={12}>
                <h4 className="label">Código</h4>
                <h5>
                  <b>{pedido.id.toString().padStart(5, "0")}</b>
                </h5>
              </Grid>
              <Grid item sm={3} xs={12}>
                <h4 className="label">Data/hora</h4>
                <h5>{formatDateTime(pedido.dataHora, "D/M/Y h:m")}</h5>
              </Grid>
              <Grid item sm={3} xs={12}>
                <h4 className="label">Situação</h4>
                <h5>{pedidoEvento.desc(pedido.situacao)}</h5>
              </Grid>
            </Grid>
          </div>
          <div className="main-container">
            <h3>Itens</h3>
            <Grid container>
              <Grid item md={12}>
                <Table
                  tableHead={[
                    "PRODUTO",
                    "QUANTIDADE",
                    "VALOR UNITÁRIO",
                    "VALOR TOTAL",
                  ]}
                  tableData={registrosTbItens}
                />
              </Grid>
            </Grid>
          </div>
          <div className="main-container">
            <h3>Pagamento</h3>
            <Grid container>
              <Grid container style={{ marginBottom: 15 }}>
                <Grid item sm={3} xs={12}>
                  <h4 className="label">Valor itens</h4>
                  <h5>{`R$ ${(pedido.valorTotal / 100).toFixed(2)}`}</h5>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <h4 className="label">Valor frete</h4>
                  <h5>{`R$ ${(pedido.valorFrete / 100).toFixed(2)} (${
                    pedido.servicoFrete
                  })`}</h5>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <h4 className="label">Valor total</h4>
                  <h5>{`R$ ${(
                    (pedido.valorTotal + pedido.valorFrete) /
                    100
                  ).toFixed(2)}`}</h5>
                </Grid>
                <Grid item sm={3} xs={12}>
                  <h4 className="label">Quantidade de parcelas</h4>
                  <h5>{pedido.numeroParcelas}</h5>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md={12}>
                  <Table
                    tableHead={["MÊS/ANO FATURA", "VALOR", "SITUACAO"]}
                    tableData={registrosTbPagamentos}
                  />
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className="main-container">
            <h3>Eventos</h3>
            <Grid container>
              <Grid item md={12}>
                <Table
                  tableHead={["EVENTO", "DATA/HORA", "ANOTAÇÃO", "ANEXO"]}
                  tableData={registrosTbEventos}
                />
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </>
  );
};

export default Pedido;

const montarTabelaItens = (itens = []) => {
  const registros = [];

  let valorTotal = 0;

  itens.forEach((item) => {
    valorTotal += item.pedidoItemValor * item.pedidoItemQtd;

    registros.push([
      <p>{item.produtoNome}</p>,
      item.pedidoItemQtd,
      `R$ ${(item.pedidoItemValor / 100).toFixed(2)}`,
      `R$ ${((item.pedidoItemValor * item.pedidoItemQtd) / 100).toFixed(2)}`,
    ]);
  });

  registros.push([
    "",
    "",
    <b>Total:</b>,
    `R$ ${(valorTotal / 100).toFixed(2)}`,
  ]);

  return registros;
};

const montarTabelaPagamentos = (pagamentos = [], history) => {
  const registros = [];

  pagamentos.forEach((pagamento) => {
    registros.push([
      <p>{`${pagamento.mes}/${pagamento.ano}`}</p>,
      <p>{(pagamento.valor / 100).toFixed(2)}</p>,
      <p>{pagamento.faturaPagamento ? "Pago" : "Pendente"}</p>,
      // <Button title="Abrir pagamento" round justIcon size="sm" color="info" onClick={() => history.push(`/app/pagamento/${pagamento.id}`)}>
      //     <Description />
      // </Button>
    ]);
  });

  return registros;
};

const montarTabelaEventos = (eventos = []) => {
  const registros = [];

  eventos.forEach((evento) => {
    const linkAnexo = evento.pedidoEventoAnexo
      ? `${serverHost()}/${evento.pedidoEventoAnexo}`
      : undefined;

    registros.push([
      <p>{pedidoEvento.desc(evento.pedidoEvento)}</p>,
      <p>{formatDateTime(evento.pedidoEventoMomento, "D/M/Y h:m")}</p>,
      <p>{evento.pedidoEventoAnotacao ? evento.pedidoEventoAnotacao : "-"}</p>,
      linkAnexo ? (
        <a target="_blank" href={linkAnexo}>
          Visualizar
        </a>
      ) : (
        ""
      ),
    ]);
  });

  return registros;
};

const DialogoConfirmacaoCancelamento = ({
  open,
  handleConfirm,
  handleClose,
}) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">
      {"Confirma o cancelamento do pedido?"}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        Não será possível desfazer o cancelamento. Caso mude de ideia, será
        necessário criar um novo pedido.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleConfirm} variant="contained">
        Confirmar cancelamento do pedido
      </Button>
      <Button onClick={handleClose} variant="contained" autoFocus>
        Fechar
      </Button>
    </DialogActions>
  </Dialog>
);
